<template>
  <component :is="component" :props="props"></component>
</template>

<script>
export default {
  name: "RenderComponente",
  props: {
    type: {
      type: String,
      required: true,
    },
    props: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    component: null,
  }),
  mounted() {
    this.component = () => import(`./${this.type}`);
  },
};
</script>
